// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------------------------------
    Datepicker nav
   ------------------------------------------------- */
.air-datepicker-nav {
  display: flex;
  justify-content: space-between;
  border-bottom: 0px solid var(--adp-border-color-inner);
  min-height: var(--adp-nav-height);
  padding: var(--adp-padding);
  box-sizing: content-box;
}
.-only-timepicker- .air-datepicker-nav {
  display: none;
}

.air-datepicker-nav--title,
.air-datepicker-nav--action {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

/*  Navigation action
   ------------------------------------------------- */
.air-datepicker-nav--action {
  width: var(--adp-nav-action-size);
  border-radius: var(--adp-border-radius);
  user-select: none;
}
.air-datepicker-nav--action:hover {
  background: var(--adp-background-color-hover);
}
.air-datepicker-nav--action:active {
  background: var(--adp-background-color-active);
}
.air-datepicker-nav--action.-disabled- {
  visibility: hidden;
}
.air-datepicker-nav--action svg {
  width: 32px;
  height: 32px;
}
.air-datepicker-nav--action path {
  fill: none;
  stroke: var(--adp-nav-arrow-color);
  stroke-width: 2px;
}

/*  Navigation title
   ------------------------------------------------- */
.air-datepicker-nav--title {
  border-radius: var(--adp-border-radius);
  padding: 0 8px;
  color: var(--adp-color);
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.air-datepicker-nav--title i {
  font-style: normal;
  color: var(--adp-color);
  margin-left: 0.3em;
}
.air-datepicker-nav--title:hover {
  background: var(--adp-background-color-hover);
}
.air-datepicker-nav--title:active {
  background: var(--adp-background-color-active);
}
.air-datepicker-nav--title.-disabled- {
  cursor: default;
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/libs/air-date-picker/src/datepickerNav.scss"],"names":[],"mappings":"AAAA;;sDAAA;AAIA;EACE,aAAA;EACA,8BAAA;EACA,sDAAA;EACA,iCAAA;EACA,2BAAA;EACA,uBAAA;AAAF;AAEE;EACE,aAAA;AAAJ;;AAGA;;EAEE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;sDAAA;AAGA;EACE,iCAAA;EACA,uCAAA;EACA,iBAAA;AADF;AAGE;EACE,6CAAA;AADJ;AAIE;EACE,8CAAA;AAFJ;AAKE;EACE,kBAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;AAJJ;AAOE;EACE,UAAA;EACA,kCAAA;EACA,iBAAA;AALJ;;AASA;sDAAA;AAGA;EACE,uCAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAPF;AASE;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;AAPJ;AAUE;EACE,6CAAA;AARJ;AAWE;EACE,8CAAA;AATJ;AAYE;EACE,eAAA;EACA,gBAAA;AAVJ","sourcesContent":["/* -------------------------------------------------\n    Datepicker nav\n   ------------------------------------------------- */\n\n.air-datepicker-nav {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 0px solid var(--adp-border-color-inner);\n  min-height: var(--adp-nav-height);\n  padding: var(--adp-padding);\n  box-sizing: content-box;\n\n  .-only-timepicker- & {\n    display: none;\n  }\n}\n.air-datepicker-nav--title,\n.air-datepicker-nav--action {\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n}\n\n/*  Navigation action\n   ------------------------------------------------- */\n\n.air-datepicker-nav--action {\n  width: var(--adp-nav-action-size);\n  border-radius: var(--adp-border-radius);\n  user-select: none;\n\n  &:hover {\n    background: var(--adp-background-color-hover);\n  }\n\n  &:active {\n    background: var(--adp-background-color-active);\n  }\n\n  &.-disabled- {\n    visibility: hidden;\n  }\n\n  svg {\n    width: 32px;\n    height: 32px;\n  }\n\n  path {\n    fill: none;\n    stroke: var(--adp-nav-arrow-color);\n    stroke-width: 2px;\n  }\n}\n\n/*  Navigation title\n   ------------------------------------------------- */\n\n.air-datepicker-nav--title {\n  border-radius: var(--adp-border-radius);\n  padding: 0 8px;\n  color: var(--adp-color);\n  text-align: center;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n\n  i {\n    font-style: normal;\n    color: var(--adp-color);\n    margin-left: .3em;\n  }\n\n  &:hover {\n    background: var(--adp-background-color-hover);\n  }\n\n  &:active {\n    background: var(--adp-background-color-active);\n  }\n\n  &.-disabled- {\n    cursor: default;\n    background: none;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
